import React from 'react';
import {observer} from 'mobx-react';

@observer
class ModalInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div role="dialog">
                <div className="order-processing-container">
                    <div>
                        <div
                            className="form-label"
                            style={{fontSize: 24}}
                        >
                            Order Processing
                        </div>
                        <div style={{fontSize: 42, paddingTop: 24}}>
                            <i className="fas fa-circle-notch fa-spin fast-spin"></i>
                        </div>
                        <div
                            style={{paddingTop: 24, fontSize: 18}}
                            className="form-label"
                            aria-label="Please wait"
                        >
                            Please wait
                        </div>
                        <div style={{paddingTop: 6}}>Please stay on this page until your order is done processing.</div>
                    </div>
                </div>
                <div className="order-processing" />
            </div>
        );
    }
}
export default ModalInfo;
